import {ActionConfig, IndexConfig, PaginationConfig, SelectionConfig, TableConfig, TimelineConfig} from "../model/ColumnConfig";
import {TableRow} from "../model/TableRow";
import {MatTableDataSource} from "@angular/material/table";

export class EmptyValue {

  public static readonly SELECTION_CONFIG: SelectionConfig<any> = {
    enable: false,
  }

  public static readonly ACTION_CONFIG: ActionConfig<any> = {
    enable: false,
    actions: []
  }

  public static readonly INDEX_CONFIG: IndexConfig = {
    enable: false,
  }

  public static readonly PAGINATION_CONFIG: PaginationConfig = {
    enable: false,
    size: 0,
    sizes: []
  }


  public static readonly TABLE_CONFIG: TableConfig<any> = {
    columnsCfg: [],
    selectionCfg: EmptyValue.SELECTION_CONFIG,
    actionCfg: EmptyValue.ACTION_CONFIG,
    indexCfg: EmptyValue.INDEX_CONFIG,
    paginationCfg: EmptyValue.PAGINATION_CONFIG
  }

  public static readonly TIMELINE_CONFIG: TimelineConfig = {
    enable: false
  };

  public static readonly MAT_TABLE_DATA_SOURCE: MatTableDataSource<TableRow<any>> = new MatTableDataSource();
}
